"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Function defines what language should be displayed with macro fallback
 * @param macros
 * @param userLanguages
 * @param availableLanguages
 * @param defaultLanguage
 */
exports.pickLanguageAccordingToUserLanguagesWithMacrosFallback = (macros, userLanguages, availableLanguages, defaultLanguage) => {
    const splittedMacro = macros
        .map(macro => ({
        macro: macro.split('-')[0],
        from: macro
    }))
        .filter(d => !availableLanguages.includes(d.macro));
    const pickLanguage = exports.pickLanguageAccordingToUserLanguages(userLanguages, [...availableLanguages, ...splittedMacro.map(d => d.macro)], defaultLanguage);
    const isMacro = splittedMacro.map(d => d.macro.toLowerCase()).includes(pickLanguage.toLowerCase());
    if (isMacro) {
        const correspondingMacro = splittedMacro === null || splittedMacro === void 0 ? void 0 : splittedMacro.find(d => d.macro === pickLanguage);
        const correspondingavailableLanguage = availableLanguages.find(d => d.toLowerCase() === (correspondingMacro === null || correspondingMacro === void 0 ? void 0 : correspondingMacro.from.toLowerCase()));
        return correspondingavailableLanguage || defaultLanguage;
    }
    else {
        return pickLanguage;
    }
};
/**
 * Function defines what language should be displayed
 * @param userLanguages
 * @param availableLanguages
 * @param defaultLanguage
 */
exports.pickLanguageAccordingToUserLanguages = (userLanguages, availableLanguages, defaultLanguage) => {
    const originalSorted = [...availableLanguages].sort().reverse();
    const sortedLowerCase = originalSorted.map(d => d.toLowerCase());
    let choosedLanguage;
    let i = 0;
    do {
        const userLanguage = userLanguages[i].toLowerCase();
        const indexPerfectMatching = sortedLowerCase.indexOf(userLanguage);
        const indexPartialMatching = sortedLowerCase
            .indexOf(userLanguage.split('-')[0]);
        if (indexPerfectMatching > -1) {
            choosedLanguage = originalSorted[indexPerfectMatching];
        }
        else if (indexPartialMatching > -1) {
            choosedLanguage = originalSorted[indexPartialMatching];
        }
        i++;
    } while (!choosedLanguage && i < userLanguages.length);
    return choosedLanguage || defaultLanguage;
};
//# sourceMappingURL=index.js.map